module.exports = __webpack_public_path__ + "static/media/feature-9.858c17b7.jpg";